// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"59":"c119a4a3","207":"c29fab3d","213":"6b31146f","239":"99ddee8b","368":"3d2dcbdf","453":"ae9c510e","987":"93ea7f1c"}[chunkId] + ".chunk.js";
};